import React, { useEffect, useRef, useState } from "react";
import { apiRequest } from "../apiService/allapi";
import BankDetalis from "./BankDetalis";
import AllAchivers from "./AllAchivers";
import Slider from "react-slick";

const Shipping = () => {
  const [news, setNews] = useState([]);
  const [achiver, setAchiver] = useState([]);
  const [rewardAchiver, setRewardAchiver] = useState([]);

  const token = localStorage.getItem("token");
  const marqueeRef = useRef(null);

  function NextArrow({ onClick }) {
    return (
      <button className="custom-next" onClick={onClick}>
        ❯
      </button>
    );
  }

  function PrevArrow({ onClick }) {
    return (
      <button className="custom-prev" onClick={onClick}>
        ❮
      </button>
    );
  }


  const getNews = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest("/AppInfo/getNews", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === "success") {
        setNews(res.data.data);
      }
    } catch (error) {
      console.log("News API Error:", error);
    }
  };

  const getAchiver = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest("/Achivers/getTopAchivers", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === "success") {
        setAchiver(res.data.data);
      }
    } catch (error) {
      console.log("News API Error:", error);
    }
  };

  const getRewardAchiver = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await apiRequest("/Achivers/getRewardAchivers", "GET", null, {
        Authorization: `Bearer ${token}`,
      });

      if (res?.data?.status === "success") {
        setRewardAchiver(res.data.data);
      }
    } catch (error) {
      console.log("News API Error:", error);
    }
  };

 const sliderSettings = {
  dots: false,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

  useEffect(() => {
    getNews();
    getAchiver();
    getRewardAchiver();
  }, []);

  const handleMouseOver = () => {
    marqueeRef.current.stop();
  };

  const handleMouseOut = () => {
    marqueeRef.current.start();
  };

  return (
    <>
      <div className="col-md-8 col-sm-12 col-lg-8 mx-auto mb-5">
        <div className="exp-ful-box">
          <div className="title-exp">
            <center>
              <a href="/">LATEST NEWS</a>
            </center>
          </div>

          <marquee
            ref={marqueeRef}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
            scrollAmount="2"
            direction="up"
            style={{ height: "142px", textAlign: "left" }}
          >
            <div className="news-content">
              {news.length > 0 ? (
                news.map((item) => (
                  <div key={item.newsID} className="mb-4">
                    <h5 className="fw-bold mb-2 text-center">
                      {item.newsName}
                    </h5>

                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.newsDesc,
                      }}
                    />
                  </div>
                ))
              ) : (
                <p>No News Available</p>
              )}
            </div>
          </marquee>

          <div className="readmore-exp">
            <a href="/">Read more</a>
          </div>
        </div>
      </div>

      {/* TOP ACHIEVER */}

      <section className="achiver-section">
        <div className="container">
          <div className="bank-heading">
            <h2>AIRCENT BUSINESS CORPORATION</h2>
            <p>Top Achievers & Latest News</p>
          </div>

          <div class="section-title">
            <h5>TOP ACHIEVER</h5>

            <div class="section-borders">
              <span></span>
              <span class="black-border"></span>
              <span></span>
            </div>
          </div>
          <div className="mt-4 achiver-sec">
            <Slider {...sliderSettings}>
              {achiver?.map((item) => (
                <div key={item.achiverId} className="px-2">
                  <div className="achiver-card">
                    <img
                      src={`${process.env.REACT_APP_IMAGE_BASE_URL}${item.imageUrl}`}
                      alt={item.name}
                      className="achiver-img"
                    />

                    <div className="achiver-content">
                      <h5>{item.name}</h5>

                      <p>
                        <strong>Member ID:</strong> {item.memberId}
                      </p>

                      <p>
                        <strong>Achievement:</strong> {item.achiveName}
                      </p>

                      {item.cityName && (
                        <p>
                          <strong>City:</strong> {item.cityName}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      {/* TOP REWARD ACHIEVER */}

      <section className="achiver-section">
        <div className="container">
          {/* <div className="bank-heading">
            <h2>REWARD ACHIEVER</h2>
            <p>Top Achievers & Latest News</p>
          </div> */}
          <div class="section-title">
            <h5>REWARD ACHIEVER</h5>

            <div class="section-borders">
              <span></span>
              <span class="black-border"></span>
              <span></span>
            </div>
          </div>
          <div className="mt-4">
            <Slider {...sliderSettings}>
              {rewardAchiver?.map((item) => (
                <div key={item.achiverId} className="px-2">
                  <div className="achiver-card">
                    <img
                      src={`${process.env.REACT_APP_IMAGE_BASE_URL}${item.imageUrl}`}
                      alt={item.name}
                      className="achiver-img"
                    />

                    <div className="achiver-content">
                      <h5>{item.name}</h5>

                      <p>
                        <strong>Member ID:</strong> {item.memberId}
                      </p>

                      <p>
                        <strong>Achievement:</strong> {item.achiveName}
                      </p>

                      {item.cityName && (
                        <p>
                          <strong>City:</strong> {item.cityName}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      <AllAchivers />
      {token && <BankDetalis />}

      <section className="shipping my-64" id="shipping">
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-xxl-3 col-sm-6">
              <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
                <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                  <i className="ph-fill ph-car-profile" />
                </span>

                <div>
                  <h6 className="mb-0">Free Shipping</h6>

                  <span className="text-sm text-heading">
                    Free shipping all over the US
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-sm-6">
              <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
                <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                  <i className="ph-fill ph-hand-heart" />
                </span>

                <div>
                  <h6 className="mb-0">100% Satisfaction</h6>

                  <span className="text-sm text-heading">
                    Free shipping all over the US
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-sm-6">
              <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
                <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                  <i className="ph-fill ph-credit-card" />
                </span>

                <div>
                  <h6 className="mb-0">Secure Payments</h6>

                  <span className="text-sm text-heading">
                    Free shipping all over the US
                  </span>
                </div>
              </div>
            </div>

            <div className="col-xxl-3 col-sm-6">
              <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2">
                <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                  <i className="ph-fill ph-chats" />
                </span>

                <div>
                  <h6 className="mb-0">24/7 Support</h6>

                  <span className="text-sm text-heading">
                    Free shipping all over the US
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Shipping;
